import { render } from "./Agreement.vue?vue&type=template&id=2ce08454&scoped=true"
const script = {}

import "./Agreement.vue?vue&type=style&index=0&id=2ce08454&scoped=true&lang=css"

import exportComponent from "F:\\unilearn\\unilearn-web-vue3\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce08454"]])

export default __exports__